import { getBootstrapData } from '@experience/core-hostapp-share-lib';
import { computed } from 'vue';

export const useBootstrapExperiments = () => {
  const bootstrapData = getBootstrapData();

  const experiments = computed(() => {
    return bootstrapData.experiments.reduce((acc: Record<string, string>, exp) => {
      acc[exp.name] = exp.variant;

      return acc;
    }, {});
  });

  const getExperimentVariant = (experimentName: string): string | undefined => {
    return experiments.value[experimentName];
  };

  const isExperimentVariantActive = (experimentName: string, variant: string): boolean => {
    return experiments.value[experimentName] === variant;
  };

  return {
    experiments,
    getExperimentVariant,
    isExperimentVariantActive,
  };
};
